import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { LayoutDashboard, MessageSquare, ListChecks, User, Briefcase, Mic, Sparkles, Calculator, Hammer } from 'lucide-react';
import { useTranslation } from '../hooks/useTranslation';
import { useAuth } from '../context/AuthContext';

const MobileNav = () => {
  const location = useLocation();
  const { t } = useTranslation();
  const { user } = useAuth();

  const modules = user?.modules_enabled || { team: true, cfo: true, studio: true };
  const rawNav = [
    { path: '/dashboard', icon: LayoutDashboard, labelKey: 'nav.home' },
    { path: '/chat', icon: MessageSquare, labelKey: 'nav.atlas' },
    { path: '/driving', icon: Mic, labelKey: 'nav.drive' },
    { path: '/decisions', icon: ListChecks, labelKey: 'nav.tracker' },
    { path: '/business', icon: Briefcase, labelKey: 'nav.biz' },
    { path: '/studio', icon: Sparkles, labelKey: 'nav.studio', module: 'studio' },
    { path: '/cfo', icon: Calculator, labelKey: 'nav.cfo', module: 'cfo' },
    { path: '/team', icon: Hammer, labelKey: 'nav.team', module: 'team' },
    { path: '/profile', icon: User, labelKey: 'nav.profile' },
  ];
  const navItems = rawNav.filter(item => !item.module || modules[item.module]);

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-atlasCard/95 backdrop-blur-lg border-t border-atlasBorder z-50 lg:hidden">
      <ul className="flex items-center justify-around py-2">
        {navItems.map(({ path, icon: Icon, labelKey }) => {
          const isActive = location.pathname === path;
          const label = t(labelKey);
          return (
            <li key={path}>
              <NavLink
                to={path}
                data-testid={`mobile-nav-${label.toLowerCase()}`}
                className={`flex flex-col items-center gap-1 px-2 py-2 rounded-lg transition-all ${
                  isActive 
                    ? 'text-atlasCyan' 
                    : 'text-atlasTextSecondary'
                }`}
              >
                <Icon className="w-5 h-5" />
                <span className="text-xs">{label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MobileNav;
